import Modal from 'react-overlays/Modal';
import styled, { css } from 'styled-components/macro';

export const Backdrop = styled.div<{ backdropBackgroundColor?: string; zIndex?: number }>`
  position: fixed;
  top: ${({ theme }) => theme.spacing.zero};
  right: ${({ theme }) => theme.spacing.zero};
  bottom: ${({ theme }) => theme.spacing.zero};
  left: ${({ theme }) => theme.spacing.zero};
  z-index: ${({ zIndex, theme }) => (zIndex ? zIndex : theme.zIndex.zIndex5)};

  background-color: ${({ theme, backdropBackgroundColor }) =>
    backdropBackgroundColor ? backdropBackgroundColor : theme.colors.black_100};

  opacity: 0.75;
`;

export const RandomlyPositionedModal = styled(Modal)<{
  maxWidth?: string;
  maxHeight?: string;
  borderRadius?: string;
  backgroundColor?: string;
  color?: string;
  padding?: string;
  additionalStyle?: any;
}>`
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: ${({ theme }) => theme.zIndex.zIndex6};

  display: block;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || '30rem'};

  padding: ${({ padding, theme }) => padding || theme.spacing.two};

  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '8px')};

  color: ${({ theme, color }) => color || theme.colors.black_5};

  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.black_5};
  outline: none;

  box-shadow: 0 2px 10px 0 rgba(37, 40, 43, 0.25);
  transform: translate(-50%, -50%);

  ${({ maxHeight }) =>
    maxHeight &&
    css`
      max-height: ${maxHeight};
      overflow-y: auto;
      scrollbar-width: thin;
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-width: 95%;
    padding: ${({ padding, theme }) => padding || `${theme.spacing.two} ${theme.spacing.zero_3}`};
  }

  ${({ additionalStyle }) => additionalStyle && additionalStyle}
`;

export const Title = styled.h3<{ mb?: string }>`
  height: 1.5rem;

  margin-bottom: ${({ theme, mb }) => (mb ? mb : theme.spacing.one_2)};

  color: ${({ theme }) => theme.colors.black_100};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
  text-align: left;
`;

export const CrossMarkIconWrapper = styled.div`
  cursor: pointer;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: none;
  }
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.black_100};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  font-family: ${({ theme }) => theme.fontFamily.regular};
`;
